var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharterSchool({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.272,
    height: 25.445,
    viewBox: "0 0 28.272 25.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8f003c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "domain_FILL0_wght400_GRAD0_opsz48",
    className: "cls-1",
    d: "M4,31.445V6H17.783v5.831h14.49V31.445Zm2.12-2.12H9.831V25.614H6.12Zm0-5.831H9.831V19.783H6.12Zm0-5.831H9.831V13.952H6.12Zm0-5.831H9.831V8.12H6.12Zm5.831,17.493h3.711V25.614H11.952Zm0-5.831h3.711V19.783H11.952Zm0-5.831h3.711V13.952H11.952Zm0-5.831h3.711V8.12H11.952Zm5.831,17.493H30.152V13.952H17.783v3.711H20.61v2.12H17.783v3.711H20.61v2.12H17.783Zm6.538-9.542v-2.12h2.12v2.12Zm0,5.831v-2.12h2.12v2.12Z",
    transform: "translate(-4 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharterSchool);
export default __webpack_public_path__ + "static/media/charter-school.0d9250b12055f3682f93dab4aa1777bd.svg";
export { ForwardRef as ReactComponent };